module.exports = __webpack_public_path__ + "static/media/need-cost.5da015f8.jpg";